import { Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import { Button, Grid } from 'semantic-ui-react';
import MyTextInput from '../../app/common/form/MyTextInput';
import { useStore } from '../../app/stores/store';
import { useEffect, useState } from 'react';
import { loginuserById } from '../../app/models/user';
import * as Yup from 'yup';
import './Loginpagestyle.css';
import { useNavigate } from 'react-router-dom';

export default observer(function Vaultloginform() {
  const { userStore } = useStore();
  const history = useNavigate();
  const {
    loginFormRegister,
    instantpagecustomerRegister,
    registeredCustomerName,
    instantpageRoleIdValidation,
  } = userStore;
  const initialState: any = {
    id: '',
    userName: '',
    email: '',
    password: '',
    confirm_password: '',
    customerName: '',
    departmentName: '',
  };
  const [loginInfo, setLoginInfo] = useState<loginuserById>(initialState);
  useEffect(() => {
    instantpagecustomerRegister();
    // eslint-disable-next-line
  }, []);
  const handleFormSubmit = async (
    values: loginuserById,
    { setSubmitting }: any,
  ) => {
    const data = {
      ...values,
      userName: values.userName,
      email: values.email,
      password: values.password,
      companyName: values.companyName,
      departmentName: values.departmentName,
      roleId: instantpageRoleIdValidation,
    };
    setLoginInfo(data);
    loginFormRegister(data, () => history('/CustomerList'));
    setSubmitting(false);
  };
  return (
    <>
      <br />
      <br />
      <br />
      <br />
      <div className="vault-form">
        <Formik
          initialValues={loginInfo}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            handleFormSubmit(values, { setSubmitting, resetForm });
          }}
          validationSchema={Yup.object({
            userName: Yup.string()
              .min(3, 'User Name must be at least 3 characters')
              .matches(/^\S*$/, 'User Name must not contain whitespace')
              .required('User Name is required')
              .test(
                'is-valid',
                ' Already User Name is taken',
                function (value: any) {
                  return !userStore.instantpageUsernameAndEmailValidate.includes(
                    value,
                  );
                },
              ),
            email: Yup.string()
              .email('Invalid Email address')
              .required('Email is required')
              .test(
                'is-valid',
                ' Already Email id is taken',
                function (value: any) {
                  return !userStore.instantpageUsernameAndEmailValidate.includes(
                    value,
                  );
                },
              ),
            password: Yup.string().required('Password is required'),
            confirm_password: Yup.string()
              .required('Confirm Password is required')
              .test('passwords-match', 'Password must match', function (value) {
                return this.parent.password === value;
              }),
            companyName: Yup.string()
              .test(
                'is-valid',
                ' Already Customer Name is taken',
                function (value: any) {
                  return !registeredCustomerName.includes(value);
                },
              )
              .test(
                'not-empty',
                'Customer Name is required',
                function (value: any) {
                  return value !== '';
                },
              )
              .required('Customer Name is required'),
            departmentName: Yup.string().required(
              'Department Name is required',
            ),
          })}
        >
          {({ handleSubmit, isSubmitting, dirty, isValid }: any) => (
            <>
              <h1
                className="VaultLogin-GetStart"
                // style={{color: "rgb(33 133 208)"}}
              >
                Get Started
              </h1>
              <Form className="ui form error" onSubmit={handleSubmit}>
                <Grid container columns={2} className="VaultForm-container">
                  <Grid.Column
                    mobile={16}
                    computer={16}
                    tablet={16}
                    className="VaultForm-container-div"
                  >
                    <MyTextInput
                      style={{ border: '1px solid rgb(244 244 244' }}
                      name="userName"
                      placeholder={'User Name'}
                    />
                  </Grid.Column>
                  <Grid.Column
                    mobile={16}
                    computer={16}
                    tablet={16}
                    className="VaultForm-container-div"
                  >
                    <MyTextInput
                      style={{ border: '1px solid rgb(244 244 244' }}
                      name="email"
                      placeholder={'Email'}
                    />
                  </Grid.Column>

                  <Grid.Column
                    mobile={16}
                    computer={16}
                    tablet={16}
                    className="VaultForm-container-div"
                  >
                    <MyTextInput
                      style={{ border: '1px solid rgb(244 244 244' }}
                      name="password"
                      placeholder={'Password'}
                      type="password"
                    />
                  </Grid.Column>
                  <Grid.Column
                    mobile={16}
                    computer={16}
                    tablet={16}
                    className="VaultForm-container-div"
                  >
                    <MyTextInput
                      style={{ border: '1px solid rgb(244 244 244' }}
                      name="confirm_password"
                      placeholder={'Confirm Password'}
                      type="password"
                    />
                  </Grid.Column>
                  <Grid.Column
                    mobile={16}
                    computer={16}
                    tablet={16}
                    className="VaultForm-container-div"
                  >
                    <MyTextInput
                      style={{ border: '1px solid rgb(244 244 244' }}
                      name="companyName"
                      placeholder={'Customer Name'}
                    />
                  </Grid.Column>
                  <Grid.Column
                    mobile={16}
                    computer={16}
                    tablet={16}
                    className="VaultForm-container-div"
                  >
                    <MyTextInput
                      style={{ border: '1px solid rgb(244 244 244' }}
                      name="departmentName"
                      placeholder={'department Name'}
                    />
                  </Grid.Column>

                  <Grid.Column
                    mobile={16}
                    computer={16}
                    tablet={16}
                    style={{ float: 'right', marginTop: '15px' }}
                  >
                    <Button
                      style={{ width: '110px', height: '40px' }}
                      disabled={!isValid || !dirty || isSubmitting}
                      positive
                      content={isSubmitting ? 'Submitting...' : 'Submit'}
                      type="submit"
                    >
                      Submit
                    </Button>
                  </Grid.Column>
                </Grid>
              </Form>
            </>
          )}
        </Formik>
      </div>
    </>
  );
});
